// extracted by mini-css-extract-plugin
module.exports = {"default-arrows-container":"_9330de7794--default-arrows-container--Vy8RU","default-arrows-wrapper":"_9330de7794--default-arrows-wrapper--T4sQF"};